import type { WhyMatched as Why } from "shared";

export function whyText(w: Why): string {
  const parts: string[] = [];
  if (w.terms.length) parts.push(`matched: ${w.terms.join(", ")}`);
  if (w.problem) parts.push(`fits problem: ${w.problem}`);
  if (w.rule) parts.push(`rule: ${w.rule}`);
  if (w.state) parts.push(`${w.state} details`);
  return parts.join(" · ");
}

export function WhyMatched({ why }: { why: Why }) {
  const t = whyText(why);
  return t ? <div className="text-xs text-slate-500">{t}</div> : null;
}
